import { connect } from 'react-redux'
import * as WordActions from '../stores/word/actions';
import * as TackActions from '../stores/tack/actions';
import * as NavigationActions from '../stores/navigation/actions';
import WordComponent from '../components/word';

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.default.user,
    word: state.default.word,
    tack: state.default.tack,
    navigation: state.default.navigation,
    loadComments: true,
    params: ownProps.match.params
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchWord: (wordText, targetLanguage) => {
      dispatch(WordActions.fetch(wordText, targetLanguage));
    },
    onResetTack: () => {
      dispatch(TackActions.reset());
    },
    onResetWord: () => {
      dispatch(WordActions.reset());
    },
    onFetchTack: (wordText) => {
      dispatch(TackActions.tackForWordText(wordText));
    },
    onSetAfterTackPath: (pathname) => {
      dispatch(NavigationActions.setAfterTackPath(pathname));
    },
    onResetAfterTackPath: () => {
      dispatch(NavigationActions.resetAfterTackPath());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WordComponent);



// WEBPACK FOOTER //
// ./src/containers/word.js